import { render, staticRenderFns } from "./ClientGeneralTab.vue?vue&type=template&id=0cc68a00&scoped=true"
import script from "./ClientGeneralTab.vue?vue&type=script&lang=ts"
export * from "./ClientGeneralTab.vue?vue&type=script&lang=ts"
import style0 from "./ClientGeneralTab.vue?vue&type=style&index=0&id=0cc68a00&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc68a00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cc68a00')) {
      api.createRecord('0cc68a00', component.options)
    } else {
      api.reload('0cc68a00', component.options)
    }
    module.hot.accept("./ClientGeneralTab.vue?vue&type=template&id=0cc68a00&scoped=true", function () {
      api.rerender('0cc68a00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/components/ClientGeneralTab.vue"
export default component.exports